import React from "react";
import PropTypes from "prop-types";
import { getModeByTitle } from "behaviour-analyzer-shared";

// Componente Modal para mostrar la información de la modalidad
const GameSelectorModal = ({ isOpen, mode, onClose }) => {
  if (!isOpen) return null;

  const modeInfo = getModeByTitle(mode);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "30px",
          borderRadius: "12px",
          maxWidth: "600px",
          width: "90%",
          maxHeight: "80vh",
          overflowY: "auto",
          boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
        }}
      >
        <h2 style={{ 
          marginBottom: "20px",
          color: "#333",
          fontSize: "1.8rem",
          textAlign: "center",
        }}>
          {mode}
        </h2>
        <p style={{ 
          marginBottom: "30px",
          lineHeight: "1.8",
          fontSize: "1rem",
          color: "#555",
          textAlign: "justify",
        }}>
          {modeInfo?.description || "Sin información disponible"}
        </p>
        <div style={{ textAlign: "center" }}>
          <button
            onClick={onClose}
            style={{
              padding: "12px 30px",
              backgroundColor: "#3498db",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "1rem",
              fontWeight: "500",
              transition: "background-color 0.3s ease",
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#2980b9"}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#3498db"}
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

GameSelectorModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  mode: PropTypes.string,
};


export default GameSelectorModal;
